import { render, staticRenderFns } from "./Edit-Statement-COD-Branch.vue?vue&type=template&id=acd5b170&scoped=true"
import script from "./Edit-Statement-COD-Branch.vue?vue&type=script&lang=js"
export * from "./Edit-Statement-COD-Branch.vue?vue&type=script&lang=js"
import style0 from "./Edit-Statement-COD-Branch.vue?vue&type=style&index=0&id=acd5b170&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acd5b170",
  null
  
)

export default component.exports